import { EMPTY_RESULT, formatScoreWithUnit, getExpertReportResultText } from '@/entities/expert-report';

/** Результат строки заключения: чем оценены блок или итог и что из этого выставил пользователь */
export type EvaluationRowResult = {
  /** Балл, рассчитанный системой; null — блок оценён значением справочника */
  rating: number | null;
  maxRating: number | null;
  /** Балл, выставленный пользователем; null — балл не выставлялся */
  manualRating: number | null;
  /** Значение, полученное системой; null — блок оценивается баллами */
  value: string | null;
  /** Набор значений, собранный правилом расчёта; null — результат не набор */
  values: string[] | null;
  /** Значение, выбранное пользователем; null — значение не выбиралось */
  manualValue: string | null;
  /** Справочник, из которого выбирается значение блока; null — блок оценивается баллами */
  possibleValues: string[] | null;
  /** Размерность балла; null — размерность не определена или результат не балл */
  unit: string | null;
};

/**
 * Текст результата строки заключения — тот же, что стоит в ней без правки: набор значений
 * перечислением, значение справочника, балл с максимумом и размерностью либо прочерк.
 *
 * Тем же текстом результат меряется на умещение ({@link useTotalRowFit}), поэтому вид его задаёт
 * одна эта функция, а не разметка каждого места показа.
 */
export const getEvaluationRowResultText = (result: EvaluationRowResult): string => {
  if (result.values?.length) return getExpertReportResultText({ values: result.values }) ?? EMPTY_RESULT;
  if (result.possibleValues?.length || result.value !== null || result.manualValue !== null) {
    return result.manualValue ?? result.value ?? EMPTY_RESULT;
  }
  if (result.rating === null || result.maxRating === null) return EMPTY_RESULT;
  return formatScoreWithUnit(result.rating, result.maxRating, result.unit);
};
